import {
  ACCOUNT_DEFAULT_CODE,
  readAccountDefaultNumber,
  type AccountSettingsMap,
} from '@/utils/account-defaults';
import {
  COMPOSER_CORRIDOR_BUFFER_DEFAULT_M,
  COMPOSER_STOP_RADIUS_DEFAULT_M,
} from '@/components/shipment/form/domain/constants';

export type ShipmentStopRole = 'origin' | 'destination' | 'waypoint';

const STOP_RADIUS_CODE = {
  origin: ACCOUNT_DEFAULT_CODE.stopRadiusOrigin,
  destination: ACCOUNT_DEFAULT_CODE.stopRadiusDestination,
  waypoint: ACCOUNT_DEFAULT_CODE.stopRadiusWaypoint,
} as const;

/**
 * Injected at app start rather than imported from the Vuex singleton. The callers are
 * the shipment form's Pinia slices, and `@/store` reaches back into the components that
 * build that same store — the store↔utils cycle the stop hydrator already avoids.
 * Unregistered, every default below falls back to the composer's own.
 */
let accountSettings: () => AccountSettingsMap = () => ({});

export function provideAccountSettingsSource(
  source: () => AccountSettingsMap,
): void {
  accountSettings = source;
}

/** The account's default, or the composer's own when the account has never set one. */
export function stopRadiusDefaultM(role: ShipmentStopRole): number {
  return (
    readAccountDefaultNumber(accountSettings(), STOP_RADIUS_CODE[role]) ??
    COMPOSER_STOP_RADIUS_DEFAULT_M
  );
}

export function corridorBufferDefaultM(): number {
  return (
    readAccountDefaultNumber(
      accountSettings(),
      ACCOUNT_DEFAULT_CODE.routeCorridorBuffer,
    ) ?? COMPOSER_CORRIDOR_BUFFER_DEFAULT_M
  );
}
